import React from "react";
import { useSelector } from "react-redux";
import Routes from "./utils/Routes";
import { BrowserRouter } from "react-router-dom";
import { IntlProvider } from "react-intl";

import getEnvParam from "./utils/getEnvParam";
import messages from "./assets/i18n";
import "./styles/main.scss";
import moment from 'moment';
import 'moment/locale/pt-br';

const log = require("loglevel");
const logLevel = getEnvParam("REACT_APP_LOG_LEVEL") || "silent";
log.setLevel(logLevel);

function App() {
    log.info("Log Inicializando App");
    const lang = useSelector(state => state.language.name);

    moment.locale(lang);
    return (
        <IntlProvider
            locale={lang}
            timeZone="America/Sao_Paulo"
            key={lang}
            messages={messages[lang]}
            defaultLocale={lang}
        >
            <BrowserRouter>
                <Routes />
            </BrowserRouter>
        </IntlProvider>
    );
}

export default App;
